import { getData } from 'api/requests/GET_APPS';

import { getQueryKey } from 'helpers/getQueryKey';

export const getSoureAppsOptions = () => {
  return {
    queryKey: getQueryKey('APPS'),
    queryFn: () => {
      return getData();
    },
  };
};
